/**
 * @class GetIt.GridPrinter
 * @author Ed Spencer (edward@domine.co.uk)
 * Helper class to easily print the contents of a grid. Will open a new window with a table where the first row
 * contains the headings from your column model, and with a row for each item in your grid's store. When formatted
 * with appropriate CSS it should look very similar to a default grid. If renderers are specified in your column
 * model, they will be used in creating the table. Override headerTpl and bodyTpl to change how the markup is generated
 *
 * Usage:
 *
 * var grid = new Ext.grid.GridPanel({
 *   colModel: //some column model,
 *   store   : //some store
 * });
 *
 * Ext.ux.GridPrinter.print(grid);
 *
 */
Ext.ux.GridPrinter = {
    /**
     * Prints the passed grid. Reflects on the grid's column model to build a table, and fills it using the store
     * @param {Ext.grid.GridPanel} grid The grid to print
     */
    print: function(grid) {
        //We generate an XTemplate here by using 2 intermediary XTemplates - one to create the header,
        //the other to create the body (see the escaped {} below)
        var columns = grid.getColumnModel().config;

        //build a useable array of store data for the XTemplate
        var data = [];

        var html = "";

        if (grid.groupped) {
            var records = {};
            var datas = {};
            var totals = {};
            var groupedColumn = null;
            var summary = new Ext.grid.GroupSummary();
            summary.init(grid);
            grid.store.data.each(function(item) {
                var group = item.data[grid.store.groupField];
                if (!datas[group]) {
                    datas[group] = [];
                }
                if (!records[group]) {
                    records[group] = [];
                }
                var convertedData = [];
                for (var key in item.data) {
                    var value = item.data[key];
                    Ext.each(columns, function(column) {
                        if (column.dataIndex == grid.store.groupField && !groupedColumn) {
                            groupedColumn = column;
                        }
                        if (column.dataIndex == key && key != grid.store.groupField) {
                            convertedData[key] = column.renderer ? column.renderer(value, null, item) : value;
                        }
                    }, this);
                }

                datas[group].push(convertedData);
                records[group].push(item);
            });
            var columnsCopy = [];
            Ext.each(columns, function(column) {
                columnsCopy.push(column);
            });
            columns = columnsCopy.remove(groupedColumn);
            var headings = Ext.ux.GridPrinter.headerTpl.apply(columns);
            var body = Ext.ux.GridPrinter.bodyTpl.apply(columns);
            var total = Ext.ux.GridPrinter.totalTpl.apply(columns);
            var headings = new Ext.XTemplate(
                    '<table>',
                    headings);
            html = headings.apply();
            for (var p in records) {
                var data = summary.calculate(records[p], grid.view.getColumnData());

                html += "<tr><td class='group' colspan='" + columns.length + "'>" + p + "</td>";
                html += new Ext.XTemplate(
                        '<tpl for=".">',
                        body,
                        '</tpl>').apply(datas[p]);
                if (grid.hasTotals) {
                    totals[p] = {};
                    Ext.each(columns, function(column) {
                        if (column.summaryRenderer) {
                            totals[p][column.dataIndex] = column.summaryRenderer(data[column.dataIndex], null, {data: data});
                        }
                    }, this);
                    html += new Ext.XTemplate(
                            '<tpl for=".">',
                            total,
                            '</tpl>').apply(totals[p]);
                }
            }
        } else {
            grid.store.data.each(function(item) {
                var convertedData = [];

                //apply renderers from column model
                for (var key in item.data) {
                    var value = item.data[key];

                    Ext.each(columns, function(column) {
                        if (column.dataIndex == key) {
                            convertedData[key] = column.renderer ? column.renderer(value, null, item) : value;
                        }
                    }, this);
                }

                data.push(convertedData);
            });
            var headings = Ext.ux.GridPrinter.headerTpl.apply(columns);
            var body = Ext.ux.GridPrinter.bodyTpl.apply(columns);
            html = new Ext.XTemplate(
                    '<table>',
                    headings,
                    '<tpl for=".">',
                    body,
                    '</tpl>',
                    '</table>'
                    ).apply(data);
        }
        //open up a new printing window, write to it, print it and close
        var win = window.open( MXAT.commonsPath + 'vendor/PrintPreview.htm', 'printgrid');

        function checkLoad() {
            if (win.windowLoaded) {
                win.document.body.innerHTML = html;
                win.print();
                win.close();
            } else {
                setTimeout(checkLoad, 100);
            }
        }

        checkLoad();

    },

    /**
     * @property headerTpl
     * @type Ext.XTemplate
     * The XTemplate used to create the headings row. By default this just uses <th> elements, override to provide your own
     */
    headerTpl:  new Ext.XTemplate(
            '<thead><tr>',
            '<tpl for=".">',
            '<th>{header}</th>',
            '</tpl>',
            '</tr></thead>'
            ),

    /**
     * @property bodyTpl
     * @type Ext.XTemplate
     * The XTemplate used to create each row. This is used inside the 'print' function to build another XTemplate, to which the data
     * are then applied (see the escaped dataIndex attribute here - this ends up as "{dataIndex}")
     */
    bodyTpl:  new Ext.XTemplate(
            '<tr>',
            '<tpl for=".">',
            '<td>\{{dataIndex}\}</td>',
            '</tpl>',
            '</tr>'
            ),
    totalTpl:  new Ext.XTemplate(
            '<tr>',
            '<tpl for=".">',
            '<td class="total">\{{dataIndex}\}</td>',
            '</tpl>',
            '</tr>'
            )
};